<script setup lang="ts" >
import { ref, onMounted } from "vue";
import anime from "animejs";

onMounted(async () => {
  const timeControlEl = document.querySelector(".time-control-investors");
  const rullerEl = document.querySelector(".ruller-investors");
  const timeEl = document.querySelector(".time-cursor-investors input");
  const infoEls = document.querySelectorAll(".info-investors");
  const fragment = document.createDocumentFragment();
  const numberOfElements = 136;
  var timeCursorEl = document.querySelector(".time-cursor-investors");

  for (let i = 0; i < numberOfElements; i++) {
    const dotEl = document.createElement("div");
    dotEl.classList.add("line-investors");
    fragment.appendChild(dotEl);
  }

  rullerEl.appendChild(fragment);

  function dragElement(el, events) {

function getPointer(e) {
  var x = 'clientX';
  var y = 'clientY';
  var evt = e.touches ? e.touches[0] : e;
  return { x: evt[x], y: evt[y] };
}

var drag = { x: 0, y: 0, deltaX: 0, deltaY: 0, active: true, events: events || {} };
var originalX = 0;
var originalY = 0;
var pointerX = 0;
var pointerY = 0;

function move(e) {
  if (drag.active) return;
  drag.deltaX = pointerX - getPointer(e).x;
  drag.deltaY = pointerY - getPointer(e).y;
  drag.x = originalX - drag.deltaX;
  drag.y = originalY - drag.deltaY;
  if (drag.events.move) drag.events.move(drag);
}

function release(e) {
  drag.active = true;
  if (drag.events.release) drag.events.release(drag);
  document.removeEventListener('mousemove', move, false);
  document.removeEventListener('mouseup', release, false);
  document.removeEventListener('touchmove', move, false);
  document.removeEventListener('touchend', release, false);
}

function start(e) {
  if (!drag.active) return;
  e.preventDefault();
  drag.active = false;
  pointerX = getPointer(e).x;
  pointerY = getPointer(e).y;
  originalX = drag.x;
  originalY = drag.y;
  if (drag.events.begin) drag.events.begin(drag);
  document.addEventListener('mousemove', move, false);
  document.addEventListener('mouseup', release, false);
  document.addEventListener('touchmove', move, false);
  document.addEventListener('touchend', release, false);
}

el.addEventListener('mousedown', start, false);
el.addEventListener('touchstart', start, false);

return drag;

}

function pxToTime(px) {
  var height = window.innerHeight > rullerEl.offsetHeight ? rullerEl.offsetHeight  : window.innerHeight;
  var percent = px / (height);
  return percent * (timeControlAnimation.duration);
}

var time = {
  anim: null,
  start: 0,
  end: 0
};

dragElement(timeCursorEl, {
  begin: function(e) {  
    time.start = timeControlAnimation.currentTime;      
  },
  move: function(e) {
    timeControlAnimation.seek(time.start + pxToTime(-e.deltaY));
  },
  release: function(e) {
    time.end = timeControlAnimation.currentTime;         
  }
});


  const timeControlAnimation = anime
    .timeline(
      { 
        easing: "linear",
      loop: 3,
      autoplay: false,
      direction: 'alternate',
      duration:  1800
    }
      )
      .add({
        targets: ".time-cursor-investors",
        keyframes: [{ translateY: rullerEl.offsetHeight  }],       
      }      
    )      
    .add(
      {
        targets: ".time-cursor-investors input",
        value: [{ value: [0, 100] }],      
        round: 1,
        easing: "easeInOutSine",
      },
      0
    );

  for (var i = 0; i < infoEls.length; i++) {
    var infoEl = infoEls[i];

    var delay = parseFloat(anime.get(infoEl, "data-delay"));
    var direction = infoEl.classList.contains("info-bottom-investors") ? -1 : 1;

    timeControlAnimation
      .add(
        {
          targets: infoEl.querySelector(".info-bar-investors"),
          scaleY: [0, 1],
          duration: 500,
          easing: "easeInOutSine",
        },
        delay
      )
      .add(
        {
          targets: infoEl.querySelectorAll(
            ".info-label-investors,.info-label-market-investors,.info-label-pitch-investors,.info-label-inception-investors, .info-label-prototype-investors, .info-label-revenue-investors, .info-label-arr-investors, .vertical-bar-initial-investors, .vertical-bar-end-investors"
          ),
          opacity: [0, 1],
          translateY: [direction * 10, 0],
          duration: 500,
          delay: anime.stagger(500, {
            start: 10,
            direction: "normal",
          }),
          easing: "easeInOutSine",
        },
        delay
      );
  }

  setTimeout(()=>{
      timeControlAnimation.play();
    },800)
   setTimeout(()=>{
      timeControlAnimation.pause();
    },1700)
   setTimeout(()=>{
      timeControlAnimation.play();
    },3500)
    setTimeout(()=>{
      timeControlAnimation.pause();
    },6050)
    setTimeout(()=>{
      timeControlAnimation.play();
    },7200)

    setTimeout(()=>{
      timeControlAnimation.pause();
    },9000)
    setTimeout(()=>{
      timeControlAnimation.play();
    },10200)
});
</script>


<template>
  <v-container class="mt-16">

    <section class="d-sm-flex d-md-none">
      <v-row no-gutters>
        <v-col cols="12">
          <v-img src="/images/vertical-timeline.jpeg" height="100%" alt="timeline"></v-img>
        </v-col>
      </v-row>
    </section>

    <section
      class="feature-section-investors feature-section-center-investors feature-control-investors d-md-flex d-none"
    >
      <h1 class="section-title-investors text-dark">
        <span>Improved </span> <span>Timeline</span>
      </h1>
      <div class="time-control-investors feature-anim-investors">
        <div class="ruller-investors">
          <div class="time-cursor-investors color-red">
            <input value="10" />
          </div>
        </div>

        <!-- // Timeline 1 -->

        <div class="typical-timeline-investors mt-typical-investors">
          <div class="info-investors info-large-investors info-left-investors info-bottom-investors" data-delay="0">
            <div class="info-bar-investors"></div>
            <div class="info-label-investors">Inception</div>
          </div>

          <div class="animation-investors">
            <div class="animation-band-typical-inception-investors animation-delay-investors"></div>

            <div class="info-investors info-left-investors info-bottom-investors" data-delay="100">
              <div class="info-bar-investors"></div>
              <div class="info-label-investors">Incorporate</div>
            </div>
          </div>

          <div class="animation-investors">
            <div class="animation-band-investors animation-delay-typical-find-cto-investors"></div>

            <div class="info-investors info-right-investors info-top-investors" data-delay="200">
              <div class="info-bar-investors"></div>
              <div class="info-label-investors">Find CTO</div>
            </div>

            <div class="animation-band-investors animation-end-delay-typical-find-cto-investors"></div>
          </div>

          <div class="info-investors info-large-investors info-left-investors info-bottom-investors" data-delay="200">
            <div class="info-bar-investors"></div>
            <div class="info-label-investors">MVP</div>
          </div>

          <div class="animation-investors">
            <div
              class="animation-band-investors animation-delay-typical-hire-cto-team-investors"
            ></div>
            <div class="info-investors info-left-investors info-bottom-investors" data-delay="350">
              <div class="info-bar-investors"></div>
              <div class="info-label-investors">Hire CTO & Team</div>
              <!-- <div class="info-label">& Team</div> -->
            </div>
            <div
              class="animation-band-investors animation-change-investors animation-delay-typical-ramp-up-investors"
            ></div>
            <div class="info-investors info-right-investors info-top-investors" data-delay="400">
              <div class="info-bar-investors"></div>
              <div class="info-label-investors">Ramp up</div>
            </div>
          </div>

          <div class="animation-investors">
            <div class="animation-band-ramp-up-investors animation-delay-investors"></div>

            <div class="info-investors info-left-investors info-bottom-investors" data-delay="500">
              <div class="info-bar-investors"></div>
              <div class="info-label-investors">Velocity</div>
            </div>
            <div class="animation-band-investors animation-end-delay-investors"></div>
          </div>

          <div class="info-investors info-large-investors info-left-investors info-bottom-investors" data-delay="600">
            <div class="info-bar-investors"></div>
            <div class="info-label-investors">Market</div>
          </div>

          <div class="animation-investors">
            <div class="animation-band-typical-market-investors animation-delay-investors"></div>
            <div class="info-investors info-left-investors info-bottom-investors" data-delay="700">
              <div class="info-bar-investors"></div>
              <div class="info-label-investors">Pivot</div>
            </div>

            <div
              class="animation-band-investors animation-change-investors animation-delay-typical-market-fit-investors"
            ></div>
            <div class="info-investors info-right-investors info-bottom-investors" data-delay="800">
              <div class="info-bar-investors"></div>
              <div class="info-label-investors">Market fit</div>
            </div>
            <div class="animation-band-investors animation-end-delay-market-fit-investors"></div>
          </div>

          <div class="info-investors info-right-investors info-top-investors" data-delay="900">
            <div class="info-bar-investors"></div>
            <div class="info-label-investors">Revenue</div>
          </div>

          <div class="animation-investors">
            <div class="animation-band-investors animation-delay-investors"></div>
            <div
              class="info-investors info-large-investors info-left-investors info-bottom-investors"
              data-delay="1000"
            >
              <div class="info-bar-investors"></div>
              <div class="info-label-investors">Scale</div>
            </div>

            <div
              class="animation-band-investors animation-change-investors animation-delay-typical-optimize-investors"
            ></div>
            <div class="info-investors info-right-investors info-bottom-investors" data-delay="1100">
              <div class="info-bar-investors"></div>
              <div class="info-label-investors">Optimize</div>
            </div>
            <div class="animation-band-investors animation-end-delay-typical-optimize-investors"></div>
          </div>

          <div class="info-investors info-large-investors info-left-investors info-bottom-investors" data-delay="1200">
            <div class="info-bar-investors"></div>
            <div class="info-label-investors">Expand</div>
          </div>

          <div class="animation-investors">
            <div
              class="animation-band-investors animation-change-investors animation-delay-typical-grow-investors"
            ></div>
            <div class="info-investors info-right-investors info-bottom-investors" data-delay="1300">
              <div class="info-bar-investors"></div>
              <div class="info-label-investors">Grow</div>
            </div>
            <div class="animation-band-investors animation-end-delay-typical-grow-investors"></div>
          </div>

          <div class="info-investors info-right-investors info-top-investors" data-delay="1450">
            <div class="info-bar-investors"></div>
            <div class="info-label-investors">Enterprise</div>
          </div>
        </div>

        <!-- // Timeline 2 -->

        <div class="treelet-timeline-investors mt-treelet-investors">
          <div class="info-investors info-large-investors info-left-investors info-bottom-investors" data-delay="0">
            <div class="info-bar-investors"></div>
            <div class="info-label-pitch-investors">Pitch</div>
            <div class="info-label-inception-investors">Inception</div>
          </div>

          <div class="animation-investors">
            <div class="animation-band-investors animation-delay-treelet-kick-off-investors"></div>

            <div class="info-investors info-left-investors info-bottom-investors" data-delay="100">
              <div class="info-bar-investors"></div>
              <div class="vertical-bar-initial-investors">
                <span class="vertical-preseed-investors">Pre-seed</span>
              </div>
              <div class="info-label-investors">Kick-off</div>
            </div>
          </div>

          <div class="animation-investors">
            <div class="animation-band-investors animation-delay-treelet-mvp-investors"></div>

            <div class="info-investors info-large-investors info-left-investors info-bottom-investors" data-delay="200">
              <div class="info-bar-investors"></div>
              <div class="info-label-investors">MVP</div>
            </div>

            <div
              class="animation-band-investors animation-end-delay-treelet-prototype-investors"
            ></div>
          </div>

          <div class="info-investors info-right-investors info-top-investors info-bottom-investors" data-delay="200">
            <div class="info-bar-investors"></div>
            <div class="vertical-bar-end-investors">
              <span class="vertical-seed-investors">Seed</span>
            </div>

            <!-- <div class="info-label">Prototype</div> -->
            <div class="info-label-prototype-investors">Prototype</div>
          </div>

          <div class="animation-investors">
            <div class="animation-band-investors animation-delay-treelet-mvp-two-investors"></div>
            <div class="info-investors info-bottom-investors" data-delay="400">
              <div class="info-bar-investors"></div>
              <div class="info-label-investors">MVP</div>
            </div>

            <div class="info-investors info-large-investors info-left-investors info-bottom-investors" data-delay="400">
              <div class="info-bar-investors"></div>
              <div class="info-label-market-investors">Market</div>
            </div>
          </div>

          <div class="animation-investors">
            <div class="animation-band-investors animation-delay-treelet-pivot-investors"></div>

            <div class="info-investors info-left-investors info-bottom-investors" data-delay="600">
              <div class="info-bar-investors"></div>
              <div class="info-label-investors">Pivot</div>
            </div>
            <div
              class="animation-band-investors animation-end-delay-treelet-market-fit-investors"
            ></div>
          </div>

          <div class="info-investors info-left-investors info-bottom-investors" data-delay="700">
            <div class="info-bar-investors"></div>
            <div class="info-label-investors">Market fit</div>
          </div>

          <div class="animation-investors">
            <div
              class="animation-band-investors animation-end-delay-treelet-revenue-investors"
            ></div>
          </div>

          <div class="info-investors info-right-investors info-top-investors info-bottom-investors" data-delay="800">
            <div class="info-bar-investors"></div>
            <div class="vertical-bar-end-investors">
              <span class="vertical-series-a-investors">Series A</span>
            </div>

            <div class="info-label-revenue-investors">Revenue</div>
          </div>

          <div class="info-investors info-large-investors info-left-investors info-bottom-investors" data-delay="900">
            <div class="info-bar-investors"></div>
            <div class="info-label-investors">Scale</div>
          </div>

          <div class="animation-investors">
            <div
              class="animation-band-investors animation-change-investors animation-delay-treelet-optimize-investors"
            ></div>
            <div class="info-investors info-right-investors info-bottom-investors" data-delay="1000">
              <div class="info-bar-investors"></div>
              <div class="info-label-investors">Optimize</div>
            </div>
            <!-- <div class="animation-band animation-end-delay-treelet"></div> -->
            <div class="animation-band-investors animation-end-delay-treelet-arr-investors"></div>
          </div>

          <div class="info-investors info-right-investors info-top-investors info-bottom-investors" data-delay="1150">
            <div class="info-bar-investors"></div>
            <div class="vertical-bar-end-investors">
              <span class="vertical-series-b-investors">Series B</span>
            </div>

            <div class="info-label-arr-investors">ARR</div>
          </div>

          <div class="info-investors info-large-investors info-left-investors info-bottom-investors" data-delay="1250">
            <div class="info-bar-investors"></div>

            <div class="info-label-investors">Expand</div>
          </div>

          <div class="animation-investors">
            <div class="animation-band-investors animation-delay-treelet-grow-investors"></div>

            <div class="info-investors info-right-investors info-bottom-investors" data-delay="1350">
              <div class="info-bar-investors"></div>
              <div class="info-label-investors">Grow</div>
            </div>
            <div
              class="animation-band-investors animation-end-delay-treelet-enterprise-investors"
            ></div>
          </div>

          <div class="info-investors info-right-investors info-top-investors" data-delay="1450">
            <div class="info-bar-investors"></div>
            <div class="info-label-investors">Enterprise</div>
          </div>
        </div>
      </div>
    </section>
  </v-container>
</template>

<style>
.vertical-preseed-investors{
  margin-right: 35rem;
}

.vertical-seed-investors{
  margin-right: 37rem;
}

.vertical-series-a-investors{
  margin-right: 36rem;
}

.vertical-series-b-investors{
  margin-right: 35rem;
}

.feature-section-investors {
  position: relative;
  display: flex;
}

.feature-section-center-investors {
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.section-title-investors {
  font-size: 64px;
  line-height: 56px;
  letter-spacing: 0;
  margin-bottom: 5.5rem;
}

.section-title-investors span {
  display: inline-block;
}

.section-description-investors {
  font-size: 24px;
  line-height: 32px;
  letter-spacing: 0;
  margin-bottom: 3rem;
}

.feature-anim-investors {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 1310px !important;
  justify-content: center;
  height: 1400px !important;
}

.time-control-investors {
  height: 17rem;
  width: 100%;
}

.time-control-investors .ruller-investors {
  top: 0;
  width: calc(45rem + 4px);
  padding: 0 1px;
  justify-content: center;
}

.time-control-investors .line-investors {
  width: 14.4px;
  height: 0.1rem;
  background-color: currentColor;
  margin-top: 8px;
}

.time-control-investors .line-investors:nth-child(9n + 2) {
  width: 20.4px;
  height: 0.1rem;
}

.time-control-investors .line-investors:not(:last-child) {
  margin-right: 8px;
}

.time-cursor-investors {
  position: absolute;
  z-index: 2;
  top: -20px;                            
  left: 15rem;
  width: 48px;
  height: 48px;
  background-image: linear-gradient(-180deg, #ffffff 3%, #dbd6d0 100%);
  border-radius: 50%;
  cursor: grab;
}

.time-cursor-investors:active {
  cursor: grabbing;
}

.time-cursor-investors input {
  pointer-events: none;
  position: relative;
  z-index: 1;
  width: 48px;
  height: 48px;
  color: currentColor;
  font-weight: 600;
  background-color: transparent;
  border-radius: 50%;
  text-align: center;
  font-size: 15px;
}

.time-cursor-investors:before {
  content: "";
  position: absolute;
  top: 25px;
  left: 47px;
  display: block;
  width: 708px;
  height: 1px;
  background-color: #f64e4d;
}

.typical-timeline-investors {
  position: relative;
  z-index: 1;
  overflow: visible;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 8px;
  font-size: 0.75rem;
  justify-content: center;
  bottom: 750px;
}

.treelet-timeline-investors {
  position: relative;
  z-index: 1;
  overflow: visible;
  /* display: flex; */
  width: 10%;
  height: 8px;
  font-size: 0.75rem;
  justify-content: center;
  bottom: 1510px;
}

.animation-investors {
  position: relative;
  overflow: visible;
  /* display: flex; */
}

.animation-band-investors {
  position: relative;
  height: 70px;
  margin: 0 1px;
  border-radius: 4px;
}

.animation-band-typical-inception-investors{
    position: relative;
  height: 70px;
  margin: 0 1px;
  border-radius: 4px;
}

.animation-band-typical-market-investors{
    position: relative;
  height: 90px;
  margin: 0 1px;
  border-radius: 4px;
}

.animation-band-ramp-up-investors{
    position: relative;
  height: 120px;
  margin: 0 1px;
  border-radius: 4px;
}

.animation-delay-investors {
  background-color: currentColor;
  /* width: 48px; */

  width: 5px;
}

.animation-delay-typical-find-cto-investors {
  background-color: currentColor;
  width: 5px;
  height: 70px;
}

.animation-change-investors {
  background-color: currentColor;
  /* width: 156px; */
  width: 224px;
}

.animation-end-delay-investors {
  background-color: currentColor;
  border: 2px solid currentColor;
  width: 5px;
  height: 100px;
}

.animation-end-delay-typical-find-cto-investors{
    background-color: currentColor;
  border: 2px solid currentColor;
  width: 5px;
  height: 70px;
}

.animation-end-delay-typical-optimize-investors {
  background-color: currentColor;
  border: 2px solid currentColor;
  width: 5px;
  height: 80px;
}

.animation-end-delay-typical-grow-investors {
  background-color: currentColor;
  border: 2px solid currentColor;
  width: 5px;
  height: 75px;
}

.animation-end-delay-market-fit-investors {
  background-color: currentColor;
  border: 2px solid currentColor;
  width: 5px;
  height: 70px;
}

.animation-delay-typical-ramp-up-investors {
  background-color: currentColor;
  border: 2px solid currentColor;
  width: 5px;
  height: 110px;
}

.animation-delay-typical-market-fit-investors {
  background-color: currentColor;
  border: 2px solid currentColor;
  width: 5px;
  height: 60px;
}

.animation-delay-typical-optimize-investors {
  background-color: currentColor;
  border: 2px solid currentColor;
  width: 5px;
  height: 60px;
}

.animation-delay-typical-grow-investors {
  background-color: currentColor;
  border: 2px solid currentColor;
  width: 5px;
  height: 90px;
}

.animation-delay-typical-timeline-investors {
  background-color: currentColor;
  border: 2px solid currentColor;
  width: 90px;
}

.animation-delay-typical-hire-cto-team-investors {
  background-color: currentColor;
  border: 2px solid currentColor;
  width: 5px;
  height: 90px;
}

/* ======= */

.animation-delay-treelet-pivot-investors {
  background-color: green;
  /* width: 110px; */
  width: 5px;
  height: 80px;
}

.animation-delay-treelet-grow-investors {
  background-color: green;
  /* width: 115px; */
  width: 5px;
  height: 80px;
}

.animation-delay-treelet-kick-off-investors {
  background-color: green;
  /* width: 130px; */
  width: 5px;
  height: 70px;
}

.animation-delay-treelet-mvp-investors {
  background-color: green;
  /* width: 125px; */

  width: 5px;
  height: 70px;
}

.animation-delay-treelet-mvp-two-investors {
  background-color: green;
  border: 2px solid green;
  width: 5px;
  height: 150px;
}

.animation-delay-treelet-optimize-investors {
  background-color: green;
  border: 2px solid green;
  width: 5px;
  height: 145px;
}

.animation-end-delay-treelet-investors {
  background-color: green;
  border: 2px solid green;
  width: 5px;
  height: 100px;
}

.animation-end-delay-treelet-arr-investors {
  background-color: green;
  border: 2px solid green;
  width: 5px;
  height: 200px;
}
.animation-end-delay-treelet-prototype-investors {
  background-color: green;
  border: 2px solid green;
  width: 5px;
  height: 70px;
}

.animation-end-delay-treelet-market-fit-investors {
  background-color: green;
  border: 2px solid green;
  width: 5px;
  height: 90px;
}

.animation-end-delay-treelet-revenue-investors {
  background-color: green;
  border: 2px solid green;
  width: 5px;
  height: 190px;
}

.animation-end-delay-treelet-enterprise-investors {
  background-color: green;
  border: 2px solid green;
  width: 5px;
  height: 90px;
}

/* ======== */

.info-investors {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 2px;
  height: 0.3rem;
  margin: 0 1px;
}

.info-investors + .info-investors {
  margin-left: 4px;
}

.info-large-investors {
  height: 0.3rem;
}

.info-top-investors {
  bottom: 0;
  justify-content: flex-start;
  align-items: flex-end;
}

.info-bottom-investors {
  top: 0;
  justify-content: flex-end;
}

.info-bar-investors {
  position: absolute;
  width: 70px;
  height: 1px;
  background-color: currentColor;
  transform-origin: 50% 100%;
}

.info-top-investors .info-bar-investors {
  bottom: 0;
}
.info-bottom-investors .info-bar-investors {
  top: 0;
  transform-origin: 50% 0%;
}
.info-left-investors .info-bar-investors {
  left: 0;
}
.info-right-investors .info-bar-investors {
  right: 0;
}

.vertical-bar-initial-investors {
  position: absolute;
  width: 45rem;
  height: 1px;
  border-right: 2px dotted currentColor;
  transform-origin: 50% 100%;
  background-color: currentColor;
  right: 0;
}

.vertical-bar-end-investors {
  position: absolute;
  width: 45rem;
  height: 1px;
  border-left: 2px dotted currentColor;
  transform-origin: 50% 100%;
  background-color: currentColor;
}

.info-label-investors {
  white-space: nowrap;
  height: 1rem;
  padding-left: 1.2rem;
  padding-right: 0.5rem;
  line-height: 1rem;
  padding-top: 0.9rem;
}

.info-label-pitch-investors {
  white-space: nowrap;
  height: 1rem;
  padding-left: 1.2rem;
  padding-right: 0.5rem;
  line-height: 1rem;
  padding-top: 0.9rem;
}

.info-label-inception-investors {
  white-space: nowrap;
  height: 1rem;
  padding-left: 1.2rem;
  padding-right: 0.5rem;
  line-height: 1rem;
  padding-top: 0.9rem;
}

.info-label-market-investors {
  white-space: nowrap;
  height: 1rem;
  padding-left: 1.2rem;
  padding-right: 0.5rem;
  line-height: 1rem;
  padding-top: 0.9rem;
}

.info-top-investors .info-label-investors {
  margin: -4px 0 0;
} 

.info-bottom-investors .info-label-investors {
  margin: 0 0 -4px 0;
}

.info-bottom-investors .info-label-market-investors {
  margin: 0 0 -15px 0;
}

.info-bottom-investors .info-label-pitch-investors {
  margin: 0 0 -4px 0;
}

.info-bottom-investors .info-label-inception-investors {
  margin: 0 0 -20px 0;
}

.info-bottom-investors .info-label-prototype-investors {
  margin: 0 5px 10px 0;
}

.info-bottom-investors .info-label-revenue-investors {
  margin: 0 5px 10px 0;
}

.info-bottom-investors .info-label-arr-investors {
  margin: 0 5px 10px 0;
}

.mt-typical-investors {
  margin-top: 100px;
  margin-left: 40rem;
}

.mt-treelet-investors {
  margin-top: 100px;
  margin-bottom: 100px;
  margin-left: 50rem;
}
</style>
